<template>
  <div class="chat-wrapper">
    <div class="chat-content" :class="{hovered: isCopyHovered}">
      <h5 v-if="message.byRepresentative">{{message.representativeName}}</h5>
      <div :class="[message.byRepresentative ? 'bg-light-success' : 'bg-light-info' ]" class="box bg-light-success" v-html="safeMessage"></div>
      <div class="options" v-if="message.question">
        <div v-if="message.question.type === 'Multiple Choice'">
          <multiple-choice :question="message.question" :answer="answer" @change="answer = $event"></multiple-choice>
        </div>
        <div v-else-if="message.question.type === 'Exclusive Choice'">
          <exclusive-choice :question="message.question" :answer="answer" @change="answer = $event"></exclusive-choice>
        </div>
      </div>
    </div>
    <div class="chat-time text-danger" v-if="message.isTyping">Typing ...</div>
    <div class="chat-time" v-else>
      <span>{{ timestamp }}</span>
      <i @mouseover="isCopyHovered = true"
         @mouseout="isCopyHovered = false"
         @click="copyToClipboard(message.message)"
         v-if="!message.byRepresentative"
         :class="{'fa-file': highlightCopyIcon }"
         class="fa fa-file-o copy-reply-btn"
      ></i>
    </div>
  </div>
</template>

<script>
import ExclusiveChoice from './ExclusiveChoice';
import MultipleChoice from './MultipleChoice';

export default {
  name: 'chat-message',
  components: {
    ExclusiveChoice,
    MultipleChoice,
  },
  props: {
    message: Object,
  },
  data () {
    return {
      isCopyHovered: false,
      highlightCopyIcon: false,
    }
  },
  computed: {
    timestamp() {
      const date = new Date(this.message.timestamp);
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    },

    safeMessage() {
      if (this.message) {
        const decoder = document.createElement('div');
        decoder.innerText = this.message.message;
        return decoder.innerHTML;
      }
      return '';
    },

    answer: {
      get() {
        if (this.answers && this.message.question && this.message.question.id) {
          return this.answers[this.message.question.id];
        }
      },
      set(answer) {
        this.setQuestionAnswer({
          questionId: this.message.question.id,
          answer,
        });
      },
    },
  },
};
</script>

<style lang="scss">
  .copy-reply-btn {
    cursor: pointer;
    margin-left: 4px;
  }
  .chat-content.hovered {
    .box {
      background: #75DCC3 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ChatMessage.vue